import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=41d7af91"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports